export const FIAT_MAX_FRACTION = 2 as const;
export const CRYPTO_MAX_FRACTION = 8 as const;
export const PERCENT_MAX_FRACTION = 2 as const;
